import { ADVERTISER_PARAMETERS_LOG } from '../constants/all'
import { postMethod } from '../utils/api'
import Cookies from 'universal-cookie'
import { trackMixpanelEvent, setMixpanelUser } from '../config/mixpanel';
import { getAndroidUserId, isModernWebView } from '@/android/bridge';

const getOptions = ({ options = {}, searchParams = {} }) => {
  let utm_options = {}
  const required_keys = ['utm_source', 'utm_medium', 'utm_campaign']
  if (Object.keys(searchParams)?.length) {
    for (const key in searchParams) {
      if (required_keys.includes(key)) utm_options[key] = searchParams[key]
    }
  }
  return {
    Platform: typeof Android != 'undefined' ? 'android' : 'Web',
    ...utm_options,
    ...options
  }
}

export const trackEvent = ({
  name,
  options = {},
  searchParams,
  conversion = false,
  isSeeker = false,
  isJobPostedSuccessfully = false,
  conversionId = ''
}) => {
  const params = getOptions({ options, searchParams })
  if (typeof window !== 'undefined') {
    if (!isSeeker) trackMixpanelEvent(name, params);
    if (typeof Android !== 'undefined') 
      Android.logAnalyticsEvent(name, 'swipe', JSON.stringify(params))
    window.fbq('track', name, params)
    if (!conversion) window.gtag('event', name, params)
    else {
      window.gtag('event', name, {
        send_to: String(
          conversionId ? conversionId : isSeeker ? process.env.NEXT_PUBLIC_SEEKERS_GTAG_ID : process.env.NEXT_PUBLIC_GTAG_ID
        ),
        url: `${process.env.NEXT_PUBLIC_BASE_URL}/${isSeeker ? 'jobs' : 'hire'}`,
        name: name,
        ...params
      })
    }
    window.Moengage.track_event(name, params)

    const cookies = new Cookies();
   
    const googleClientId = cookies.get('_ga');
   
    const facebookPixelId = cookies.get('_fbp');
  
    const facebookClickId = cookies.get('_fbc');

    const payload = {
      name,
      ...params,
      extra: {
        google_client_id: googleClientId,
        ...(facebookPixelId && { meta_fbp: facebookPixelId }),
        ...(facebookClickId && { meta_fbc: facebookClickId })
      }
    }
    
    if (isJobPostedSuccessfully) {
      postMethod({
        url: `${ADVERTISER_PARAMETERS_LOG}`,
        data: payload,
        advParameterFlag: true
      })
    }
  }
}

export const pageview = () => {
  if (typeof window !== 'undefined') {
    window.fbq('track', 'PageView')
  }
}

export const loginTrack = ({ id, mobileNumber = null, isAndroidWebview = false }) => {
  if (typeof window !== 'undefined') {
    window.Moengage.add_unique_user_id(id)
    window.gtag('config', process.env.NEXT_PUBLIC_GTAG_ID, {
      user_id: id
    })
    setMixpanelUser(id, mobileNumber ? { mobileNumber } : {});

    if (!isAndroidWebview) {
      window.Moengage.add_mobile(mobileNumber)
    }
  }
}

export const logout = () => {
  if (typeof window !== 'undefined') {
    window.Moengage.destroy_session()
  }
}

export const addUserAttribute = ({ attr, value }) => {
  if (typeof window !== 'undefined') {
    window.Moengage.add_user_attribute(attr, value)
  }
}

export const getCurrentUserId = (loginDetails = {}) =>
  isModernWebView()
    ? getAndroidUserId()                       // Jobs / new News
    : loginDetails?.id || null;  
